module.exports = __webpack_public_path__ + "static/media/INZ1249.ca46bf70.pdf";